import { render, staticRenderFns } from "./LLPage.vue?vue&type=template&id=bfc23460&scoped=true"
import script from "./LLPage.vue?vue&type=script&lang=js"
export * from "./LLPage.vue?vue&type=script&lang=js"
import style0 from "./LLPage.vue?vue&type=style&index=0&id=bfc23460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc23460",
  null
  
)

export default component.exports